
<script>
import appConfig from '@src/app.config'
import FacilityInbox from '../../components/Facility/FacilityInbox.vue'
import FacilityScheduler from '../../components/Facility/FacilityScheduler.vue'
import FacilityFacility from '../../components/Facility/FacilityProfile.vue'

export default {
  name: 'FacilityPage',
  components: {
    'Facility-Inbox': FacilityInbox,
    'Facility-Scheduler': FacilityScheduler,
    'Facility-Facility': FacilityFacility,
  },
}
</script>


<template>
  <v-layout row wrap align-center>
    <v-flex xs12>
      <div>
        <v-card elevation="1">
        <v-tabs centered v-model="active" slider-color="primary" color="Navy">
          <v-tab>Facility Profile</v-tab>
          <v-tab-item>
            <Facility-Facility></Facility-Facility>
          </v-tab-item>
          <v-tab>Facility Inbox</v-tab>
          <v-tab-item>
            <Facility-Inbox></Facility-Inbox>
          </v-tab-item>
          <v-tab>Facility Schduler</v-tab>
          <v-tab-item>
            <Facility-Scheduler></Facility-Scheduler>
          </v-tab-item>
        </v-tabs>
        </v-card>
      </div>
    </v-flex>
  </v-layout>
</template>


<style>
.custom-card {
  background-color: #fff;
  color: rgba(0, 0, 0, 0.87);
  border-radius: 2px;
  box-shadow: 0 2px 1px -1px rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14),
    0 1px 3px 0 rgba(0, 0, 0, 0.12);
  padding: 16px;
  margin-bottom: 10px;
  width: 100%;
  min-height: 250px;
}
</style>



